import React from 'react';
import { useTranslation } from 'react-i18next';

import { captureException } from '@sentry/browser';

import config from '../../../client/config';
import useUpdateFitnessSettings from '../../../hooks/fitness/useUpdateFitnessSettings';
import { useApp } from '../../../hooks/useApp';
import ConfirmationModal from '../../ConfirmationModal/ConfirmationModal';
import { useFitnessManagerContext } from '../../FitnessManager/FitnessManagerContext';
import { pausedFitnessSettings } from '../FitnessSettingsModal/defaultFitnessSettings';

import styles from './StravaStopSharingConfirmation.scss';

export const StopSharingConfirmation = () => {
  const { t } = useTranslation('common', { useSuspense: false });
  const {
    page,
    fitnessApplicationName,
    modalManager,
  } = useFitnessManagerContext();
  const [updateFitnessSettings] = useUpdateFitnessSettings();

  const { showToast } = useApp();

  const pauseStrava = async () => {
    const input = {
      pageId: page.id,
      name: fitnessApplicationName,
      ...pausedFitnessSettings,
    };

    try {
      await updateFitnessSettings(input);
      showToast({
        message: t('strava.stopSharing.success'),
        type: 'success',
        dismissAfter: 5000,
      });
      modalManager.actions.onOpenModal('settings');
    } catch (error) {
      showToast({
        message: t('strava.stopSharing.warning'),
        type: 'warning',
        dismissAfter: 10000,
      });
      captureException(error);
    }
    modalManager.actions.onCloseModal();
  };

  const pageViewTrackingData = {
    event: 'page view',
    subtype: 'stop sharing confirmation',
    page_section: 'strava -> manage strava settings',
  };

  return (
    <ConfirmationModal
      modalTitle={t('strava.confirmationModal.title')}
      confirmButtonText={t('strava.stopSharing.confirmButton')}
      dismissButtonText={t('strava.stopSharing.cancelButton')}
      onDismiss={() => modalManager.actions.onOpenModal('settings')}
      onConfirm={pauseStrava}
      pageViewTrackingData={pageViewTrackingData}
    >
      <div className={styles.description}>
        {t('strava.confirmationModal.stopSharingModalDesc-1')}
      </div>
      <div className={styles.description}>
        {t('strava.confirmationModal.stopSharingModalDesc-2')}
      </div>

      <div className={styles.description}>
        {t('strava.confirmationModal.stopSharingModalDesc-3a')}
        <a href={`${config.baseUri}/user-account/apps`}>
          {t('strava.confirmationModal.stopSharingModalDesc-3b')}
        </a>
      </div>
    </ConfirmationModal>
  );
};

StopSharingConfirmation.displayName = 'StravaStopSharingConfirmation';
